// extracted by mini-css-extract-plugin
export default {"container":"OverbookingOrderTab_container__FC8aG","title":"OverbookingOrderTab_title__gzU-b"};